export const environment = {
  production: false,
  //regApiGatewayUrl: 'https://0v5opvqdt3.execute-api.eu-central-1.amazonaws.com/prod/',
  regApiGatewayUrl: 'https://xp2tar0jd4.execute-api.us-east-1.amazonaws.com/prod/', 
  regApiGatewayUrlWebsocket: 'wss://ws-webtest.cloudkama.com/'
                                
};
